import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import { FormFieldTime } from '@/global/components/Form'
import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'

export default function InterjornadaForm() {
    return (
        <Grid container>
            <Grid item xs={24} className="mb-4 mt-8">
                <HorizontalDivider>
                    Interjornada (intervalo entre dias)
                </HorizontalDivider>
            </Grid>
            <Grid item xs={6}>
                <FormFieldTime
                    name="horasIntervalares"
                    label="Horas intervalares"
                    placeholder="HH:mm"
                    endAdornment={
                        <IconeAjuda>
                            Esse campo determina quantas horas intervalares vão
                            ser concedidas ao funcionário sempre que ele
                            trabalhar no dia.
                            <br />
                            <br />
                            As horas intervalares serão exibidas no espelho do
                            ponto e na integração com a folha de pagamento.
                            <br />
                            <br />
                            Deixe em branco para não considerar horas
                            intervalares.
                        </IconeAjuda>
                    }
                    autoComplete="off"
                />
            </Grid>
            <Grid item xs={24} className="mb-4 mt-8">
                <HorizontalDivider>
                    Intrajornada (intervalo no mesmo dia)
                </HorizontalDivider>
            </Grid>
            <Grid item xs={6}>
                <FormFieldTime
                    name="intervaloMinimoTurnosMinutos"
                    label="Intervalo mínimo entre turnos"
                    placeholder="HH:mm"
                    endAdornment={
                        <IconeAjuda>
                            Menor intervalo permitido entre a saída de um turno
                            e a entrada do seguinte. O relatório de
                            inconsistências aponta os dias com intervalo abaixo
                            desse valor.
                            <br />
                            <br />O intervalo mínimo intrajornada na CLT (Art.
                            71) depende da duração da jornada diária: para
                            jornadas de até 4 horas não há pausa obrigatória; de
                            4 a 6 horas o descanso é de 15 minutos; e para
                            jornadas que excedem 6 horas, o intervalo é de no
                            mínimo 1 hora.
                        </IconeAjuda>
                    }
                    autoComplete="off"
                    helperText="Deixe em branco para não verificar."
                />
            </Grid>
        </Grid>
    )
}
